(function(){
    'use strict'; 
    angular.module('app').controller('AssignDriverModalController', AssignDriverModalController);
    AssignDriverModalController.$inject = [
        '$uibModalInstance',
        'selectedJobs',
        'FleetService',
        'toastr',
        '$q'
    ];

    function AssignDriverModalController(
        $uibModalInstance,
        selectedJobs,
        FleetService,
        toastr,
        $q
    ){
        const vm = this;
        vm.drivers = [];

        vm.searchDriver = searchDriver;
        vm.getDrivers = getDrivers;
        vm.assignJob = assignJob;
        vm.closeModal = closeModal;
 
        init();
        function init(){ 
            getDrivers({});
        }

        function searchDriver(driverName){
            getDrivers({
                fullName: driverName
            });
        }

        function getDrivers(filter){
            FleetService.Drivers.getAll(data => {
               vm.drivers = data.content;
            }, error => {
                console.log(error);
                toastr.error("Cannot Fetch Driver Data", error.message);
            }, angular.extend({
                active: true,
                size: 20, 
                sort: 'id,asc'
            }, filter));
        }

        function assignJob(){
            vm.loading = true;
            const jobs = selectedJobs.filter(job => {
                return job.jobStatus == 'forapproval' || job.jobStatus == 'unassigned';
            });
            const jobIds = jobs.map(job=>{ return job.id; });

            if(jobIds.length !== 0) {
                FleetService.Jobs.assign(jobIds, vm.selectedDriver.id, data => {
                    vm.loading = false;
                    toastr.success( "Jobs are successfully assigned to the driver", "Success",);
                    $uibModalInstance.close('reloadTable');
                }, error => {
                    vm.loading = false;
                    console.log(error);
                    toastr.error("Error", error.message)
                    $uibModalInstance.close('reloadTable');
                });
                return; 
            }
            
            toastr.warning( "You can only assign pending and unassigned jobs to a driver.", "Warning");
            vm.loading = false;
            $uibModalInstance.dismiss();
        }
        
        function closeModal() {
            $uibModalInstance.dismiss();
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/jobs/AssignDriverModalController.js